export default {
    aggregate: Array,
    autoSync: Boolean,
    batch: Boolean,
    data: Array | String,
    filter: Array | Object,
    group: Array | Object,
    inPlaceSort: Boolean,
    offlineStorage: String | Object,
    page: String | Number,
    pageSize: String | Number,
    schema: Object,
    serverAggregates: Boolean,
    serverFiltering: Boolean,
    serverGrouping: Boolean,
    serverPaging: Boolean,
    serverSorting: Boolean,
    sort: Array | Object,
    transport: Object,
    type: String,

    // Events
    change: Function,
    error: Function,
    push: Function,
    requestEnd: Function,
    requestStart: Function,
    sync: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoDataSourceBase/DataSourceProps.js